import MetadataStore from "./metadataStore";
import GridLayoutStore from "./gridLayoutStore";
import SynchronizationStore from "./synchronizationStore";
import SeriesListStore from "./seriesListStore";
import MeasureToolStore from "./measureToolStore";
import ToolbarStore from "./toolbarStore";
import DialogStore from "./dialogStore";
import HotkeyStore from "./hotkeyStore";
import ElementViewConfigStore from "./ElementViewConfigStore";
import LicenseStore from "./licenseStore";
import AuthStore from "./authStore"

const Store = {
  MetadataStore,
  GridLayoutStore,
  SynchronizationStore,
  SeriesListStore,
  MeasureToolStore,
  ToolbarStore,
  DialogStore,
  HotkeyStore,
  ElementViewConfigStore,
  LicenseStore,
  AuthStore,
};

export default Store;
